const mapRegistrationListResult = ({ data, dataLength }) => {
	const mappedData = data.map((item) => {
		return {
			id: item._id,
			phoneNumber: item.phoneNumber,
			organizationId: item.organizationId,
		}
	});
	return {
		data: mappedData,
		total: dataLength
	};
};

const mapRegistrationListToServiceModel = (data) => {
	const mappedData = data.map((item) => {
		const { tempId, phoneNumber, organizationId } = item;

		return {
			_id: item.id,
			phoneNumber,
			organizationId,
			tempId,
		}
	});
	return mappedData;
};

export {
	mapRegistrationListResult,
	mapRegistrationListToServiceModel,
};
